import React from 'react'
import { connect } from 'react-redux'

import {
  getShowConnections,
  getShowAllConnections,
  getShowLeftNavLabels,
  toggleConnections,
  toggleAllConnections,
  toggleLeftNavLabels,
} from 'ducks/settings'

import ToggleField from 'components/Shared/Forms/ToggleField'

const DisplaySettings = props => {
  const {
    showConnections,
    showAllConnections,
    showLeftNavLabels,
    toggleConnections,
    toggleAllConnections,
    toggleLeftNavLabels,
  } = props

  return (
    <>
      <ToggleField
        label="Do you want to see how your screens are linked?"
        helpText="Toggle this on and off at any time by pressing Shift + L"
        value={showConnections}
        inputValue="Display Screen Connections"
        onChange={toggleConnections}
      />
      {showConnections && (
        <ToggleField
          label="Show all screen connections"
          helpText="Display all screen connections at once. When off, connections are shown only for selected screens. May impact performance with many screens."
          value={showAllConnections}
          inputValue="Show All Connections"
          onChange={toggleAllConnections}
        />
      )}
      <ToggleField
        label="Show labels below left panel icons"
        helpText="Display small labels below icons in the left navigation panel"
        value={showLeftNavLabels}
        inputValue="Display Icon Labels"
        onChange={toggleLeftNavLabels}
      />
    </>
  )
}

const mapStateToProps = state => ({
  showConnections: getShowConnections(state),
  showAllConnections: getShowAllConnections(state),
  showLeftNavLabels: getShowLeftNavLabels(state),
})

const mapDispatchToProps = {
  toggleConnections,
  toggleAllConnections,
  toggleLeftNavLabels,
}

export default connect(mapStateToProps, mapDispatchToProps)(DisplaySettings)
